module.exports = __webpack_public_path__ + "img/1949-Martinsville Seven.065f4329.jpg";